class ApplicationError extends Error {
  code
  message
  data = null

  /**
   *
   * @param {string} code
   * @param {string} message
   * @param {Object|null}data
   */
  constructor(code, message, data = null) {
    super()

    this.code = code
    this.message = message
    this.data = data
  }

  /**
   *
   * @return {string}
   */
  getCode() {
    return this.code
  }

  /**
   *
   * @return {string}
   */
  getMessage() {
    return this.message
  }

  /**
   *
   * @return {null|Object}
   */
  getData() {
    return this.data
  }
}

export default ApplicationError
